import InvestorDashboard from './InvestorDashboard'

export default InvestorDashboard
